import type { WeekTab } from "./cycle";

/** The four rotation weeks as buttons, this week first. The Cycle board and Accounts use them. */
export function WeekTabs({
  tabs,
  week,
  onPick,
  testId,
  label = "Rotation week",
  small = false,
}: {
  tabs: WeekTab[];
  week: number | undefined;
  onPick: (week: number) => void;
  testId: string;
  label?: string;
  small?: boolean;
}) {
  return (
    <div className={small ? "tabs week-tabs small" : "tabs week-tabs"} role="group" aria-label={label} data-testid={`${testId}s`}>
      {tabs.map((tab) => (
        <button key={tab.week} type="button" aria-pressed={week === tab.week} data-testid={`${testId}-${tab.week}`} data-start={tab.start} onClick={() => onPick(tab.week)}>
          {tab.label}
        </button>
      ))}
    </div>
  );
}
